import { Box, CardMedia, Tooltip, Typography } from "@mui/material";
import { CiCircleQuestion } from "react-icons/ci";
import AlarmNotification from "./AlarmNotification";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
import { useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LogoROP from "../../assets/logo-rop/ROP_marca-02.png";
import { showDashboardMenus } from "./SecondHeader";

export default function Header() {
    const {
        setAsideMenuIsShrunken,
        asideMenuIsShrunken,
        selectedDashboardUsina: selectedUsina,
        isMobile,
        clientMenuResources
    } = useContext(MainContext);

    const navigate = useNavigate()

    const toggleShrink = () => {
        setAsideMenuIsShrunken(!asideMenuIsShrunken);
    };

    const path = window.location.pathname;

    const getHeaderTitle = () => {
        if (path.includes("portfolio"))
            return "Portfólio"
        if (path.includes("boletim"))
            return selectedUsina ? selectedUsina?.name : ""
        if (path.includes("usinas") || path.includes("users") || path.includes("clients") || path.includes("matriz") || path.includes("sql-queries"))
            return "Administrativo"
        if (showDashboardMenus(path, selectedUsina?.usinaIds.id))
            return selectedUsina ? selectedUsina?.name : ""
        if (path.includes("operations"))
            return "Centro de Operações Solar"
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "row", minHeight: "42px", position: "fixed", width: "100%" }}>
            {!isMobile && asideMenuIsShrunken &&
                <Box sx={{ minWidth: "42px", backgroundColor: "#353535", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <MenuIcon
                        onClick={toggleShrink}
                        style={{
                            cursor: "pointer",
                            width: "26px",
                            height: "26px",
                            color: "#FFFFFF",
                            transition: "transform 0.3s ease-in-out",
                        }}
                    />
                </Box>}
            <Box sx={{ backgroundColor: "#161616", width: "100%", display: "flex", flexDirection: "row-reverse", alignItems: "center", paddingX: "8px", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", columnGap: "8px", flexDirection: "row-reverse", alignItems: "center", }}>
                    <Tooltip title="FAQ">
                        <Box>
                            <CiCircleQuestion
                                style={{
                                    cursor: "pointer",
                                    width: "24px",
                                    height: "24px",
                                    color: "#FFFFFF",
                                    transition: "transform 0.3s ease-in-out",
                                }}
                                onClick={() => navigate("/faq")}
                            />
                        </Box>
                    </Tooltip>
                    {clientMenuResources.some(resource => resource.uri === "/User/{id}") && (
                        <Tooltip title="perfil">
                            <Box>
                                <ManageAccountsIcon
                                    style={{
                                        cursor: "pointer",
                                        width: "24px",
                                        height: "24px",
                                        color: "#FFFFFF",
                                        transition: "transform 0.3s ease-in-out",
                                    }}
                                    onClick={() => navigate("/perfil")}
                                />
                            </Box>
                        </Tooltip>)}
                    <Tooltip title="Notificações">
                        <Box>
                            <AlarmNotification />
                        </Box>
                    </Tooltip>
                </Box>
                <Box sx={{ height: "100%", display: "flex", alignItems: "center", width: "100%" }}>
                    <CardMedia
                        component="img"
                        alt="Minha Imagem"
                        sx={{
                            width: { xs: 60, md: 75 },
                            height: { xs: 30, md: 40 },
                            objectFit: "cover",
                        }}
                        image={LogoROP}
                    />
                    <Typography
                        noWrap
                        sx={{
                            borderLeft: "1px solid #FFFFFF80",
                            paddingX: "16px",
                            fontSize: "18px",
                            color: "#FFFFFF"
                        }}
                    >
                        {getHeaderTitle()}
                    </Typography>
                </Box>

            </Box>
        </Box>
    )
}